import { Select, SelectProps } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { GET } from "../../utils/ApiRequestProvider";

export interface APIDropdownCustomProps extends SelectProps {
    fetchurl?: string;
    data?: Array<any>,
    valuekey: string;
    textkey: string;
    onsuccess?: (res: Array<any>) => void;
    onerrored?: (err: string) => void;
    itemselect?: (target: any) => void;
    selectedvalue?: number | string;
    addoption?: string;
    addoptionvalue?: string;
}

export default function APIDropdownCustom(props: APIDropdownCustomProps) {
    const [selectItems, setSelectItems] = useState<Array<any>>(props.data ?? []);

    function throwError(err: string) {
        console.error(err);
        props.onerrored && props.onerrored(err);
    }

    useEffect(() => {
        if (!props.data) {
            (async () => {
                try {
                    const res = await GET(props.fetchurl ?? "/api/nothing");
                    const items = Array.isArray(res?.data)
                        ? res.data
                        : Array.isArray(res?.data?.items)
                            ? res.data.items
                            : Array.isArray(res?.data?.documents)
                                ? res.data.documents
                                : [];
                    setSelectItems(items);
                    
                } catch (err: any) {
                    throwError(err.message)
                }
            })()
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        props.onsuccess && props.onsuccess(selectItems);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectItems]);

    function onSelect(e: any) {
        const selectedItem = selectItems.find(f => String(f[props.valuekey]) === e.target.value) === undefined ? e.target.value : selectItems.find(f => f[props.valuekey] === e.target.value);
        // console.log(e);
        props.itemselect && props.itemselect(selectedItem === undefined ? e : selectedItem);
    }

    return (
        <Select {...props} onChange={onSelect}>
            {
                selectItems.map((s, i) => {
                    return (
                        <option key={i} value={s[props.valuekey]} >{s[props.textkey]}</option>
                    )
                })
            }
            {
                props.addoption === "true" && <option key="0" value={"Add " + props.addoptionvalue}>Add {props.addoptionvalue}</option>
            }
        </Select>
    )
}